// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { brandGridStyles } from "@guestsupply/App/Widgets/Brand/BrandGrid";
import { FormFieldStyle } from "@guestsupply/MobiusOverrides/FormField/FormField";
import Search from "@guestsupply/XDL/Icons/Search";
import { color, xScreen } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

brandGridStyles.centeringWrapper = {
    css: css`
        min-height: 300px;
        display: flex;
        align-items: center;
    `,
};

brandGridStyles.spinner = {
    css: css`
        margin: auto;
    `,
};

brandGridStyles.brandGridWrapper = {
    css: css`
        margin-top: 32px;
    `,
};

brandGridStyles.searchWrapper = {
    css: css`
        display: flex;
        align-items: center;
        border-top: 1px solid ${color("common.border")};
        padding-top: 12px;

        ${FormFieldStyle} {
            max-width: 500px;
            ${xScreen("lte", "md")} {
                max-width: unset;
            }
        }

        ${xScreen("lte", "xs")} {
            flex-direction: column;
            align-items: flex-start;
        }
    `,
};

brandGridStyles.search = {
    iconProps: {
        src: Search,
        css: css`
            &&& {
                width: 48px;
            }
        `,
    },
    cssOverrides: {
        formField: css`
            && input {
                padding: 0 52px 0 9px;

                &:focus {
                    padding: 0 52px 0 9px;
                }
            }
        `,
    },
};

brandGridStyles.searchTitle = {
    variant: "h5",
    as: "p",
    css: css`
        white-space: nowrap;
        margin-right: 12px;
        margin-bottom: 0;

        ${xScreen("lte", "xs")} {
            margin-bottom: 5px;
        }
    `,
};

brandGridStyles.brandsContainer = {
    gap: 20,
    css: css`
        padding-top: 20px;
    `,
};

brandGridStyles.brandItem = {
    width: [12, 6, 4, 3, 2],
};

brandGridStyles.link = {
    css: css`
        height: 100%;
        width: 100%;
    `,
};

brandGridStyles.brandItemWrapper = {
    css: css`
        border: 1px solid ${color("common.border")};
        border-radius: 4px;
        padding: 17px;
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 100%;
        width: 100%;
        justify-content: space-between;

        &:hover {
            box-shadow: 0 0 8px 0 ${color("common.ui7", 0.15)};
            color: ${color("text.link")};
        }
    `,
};

brandGridStyles.brandTitle = {
    size: 14,
    lineHeight: "16px",
    weight: "bold",
    css: css`
        text-align: center;
    `,
};

brandGridStyles.image = {
    css: css`
        width: 172px;
        height: 172px;
        margin-bottom: 17px;
        img {
            max-height: 100%;
            max-width: 100%;
            height: auto;
        }
    `,
};

brandGridStyles.resultsLabel = {
    css: css`
        text-transform: capitalize;
        border-bottom: 1px solid ${color("common.border")};
        margin-bottom: 5px;
        padding-bottom: 5px;
        padding-top: 25px;
        font-size: 20px;
        line-height: 25px;
        font-weight: 400;
    `,
};

brandGridStyles.noSearchResults = {
    css: css`
        text-transform: capitalize;
        margin: 15px 0 20px;
        padding: 10px;
    `,
};
